<header class="header">
  <div class="header-top container clearfix">
    <h2 style="text-align: center; margin: 0px;">Elektrownia Powiśle - Parking</h2>
    <nav class="nav center">
      <a href="http://elektrowniapowisle.com/">Home</a>
      <a *ngIf="!authService.user" routerLink="/reservation-retail">Rezerwacja miejsca</a>
      <a *ngIf="!isUserInRoles(['AdministratorRole','HotParkingOperatorRole'])" routerLink="/pub-hotparking">Hot Parking</a>
      <a *ngIf="!authService.user" routerLink="/login">Logowanie</a>
      <a *ngIf="isUserInRoles(['AdministratorRole','ReservationOperatorRole'])" routerLink="/reservation">Rezerwacja miejsc dla gości</a>
      <a *ngIf="isUserInRoles(['AdministratorRole','HotParkingOperatorRole'])" routerLink="/hotparking">Hot Parking</a>
      <a *ngIf="isUserInRoles(['AdministratorRole','ValidationOperatorRole'])" routerLink="/validation">Walidacja</a>
      <!--a *ngIf="isUserInRoles(['AdministratorRole','LprOperatorRole'])" routerLink="/lpr">LPR</a-->
      <div *ngIf="isUserInRoles(['AdministratorRole'])">
        <a href="javascript:void()">Administracja</a>
        <nav class="nav dropdown">
          <a *ngIf="isUserInRoles(['AdministratorRole'])" routerLink="/users/">Administracja użytkownikami</a>
          <a *ngIf="isUserInRoles(['AdministratorRole'])" routerLink="/validators/">Administracja walidatorami</a>
        </nav>
      </div>
      <div *ngIf="authService.user && !authService.user.system">
        <a href="javascript:void()">Profil</a>
        <nav class="nav dropdown">
          <a *ngIf="!authService.user.system" routerLink="/profile">Zmiana hasła</a>
        </nav>
      </div>
      <a *ngIf="authService.user" (click)="logout()">Wyloguj</a>
    </nav>
  </div>

  <div class="header-bg">
  </div>
</header>
